/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COLOR_PRIMARY, COLOR_PRODUCT, COLOR_SECONDARY } from '@lib/tools/shared/helpers/consts';
import { TColorShadeKey } from '@lib/tools/shared/helpers/interfaces';
import { createShadeVars } from '@lib/tools/views/hooks/useRetailerColors';

// Retailer dynamic colors
export const RETAILER_COLORS: Record<'primary' | 'secondary' | 'product', Record<TColorShadeKey, string>> = {
  primary: createShadeVars(COLOR_PRIMARY),
  secondary: createShadeVars(COLOR_SECONDARY),
  product: createShadeVars(COLOR_PRODUCT),
} as const;

// Static Hex colors
export const COLORS = {
  green: {
    '25': '#F2F9F5',
    '50': '#D3EDDF',
    '100': '#B0DEC6',
    '200': '#8DCFAD',
    '300': '#6AC093',
    '400': '#47B17A',
    '500': '#24A360',
    '600': '#1E8851',
    '700': '#186F41',
    '800': '#135432',
    '900': '#0D3B23',
  },
  azure: {
    '25': '#F7FAFD',
    '50': '#D8E6F3',
    '100': '#B9D1E9',
    '200': '#9ABDDF',
    '300': '#7BA9D5',
    '400': '#5C94CB',
    '500': '#3D80C1',
    '600': '#336CA2',
    '700': '#295783',
    '800': '#204364',
    '900': '#162E45',
  },
  gray: {
    '25': '#f9f9fa',
    '50': '#e0e2e7',
    '100': '#c8ccd3',
    '200': '#b0b5c0',
    '300': '#979eac',
    '400': '#7f8798',
    '500': '#667085',
    '600': '#565e70',
    '700': '#454C5A',
    '800': '#353a45',
    '900': '#252830',
  },
  warmGray: {
    '25': '#fefefe',
    '50': '#f9f9f8',
    '100': '#f4f5f2',
    '200': '#eff0ec',
    '300': '#e1e0d9',
    '400': '#e5e6e0',
    '500': '#e0e2da',
    '600': '#bcbeb7',
    '700': '#989a94',
    '800': '#747571',
    '900': '#51514e',
  },
  base: {
    black: '#232021',
    white: '#fff',
    whiteGray: '#efefef',
    red: '#f04438',
    lightRed: '#fda29b',
    green: '#12b76a',
  },
  error: {
    '50': '#fef3f2',
    '100': '#fee4e2',
    '400': '#F97066',
    '600': '#D92D20',
  },
  warning: {
    '400': '#FDB022',
  },
} as const;
